import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "view",
      entry: "Entry Fee ",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem('theme')

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>
      <div className="prince_running_match_card">

        {/* Top */}
        <div className="prince_running_match_header">

          <span className="prince_running_status">
            <span className="prince_running_status_dot"></span>
            LIVE MATCH
          </span>

          <div className="prince_running_players">

            <span>
              {runnig.Created_by.Name.length > 5
                ? `${runnig.Created_by.Name.slice(0, 5)}...`
                : runnig.Created_by.Name}
            </span>

            <b>&</b>

            <span>
              {runnig.Accepetd_By.Name.length > 5
                ? `${runnig.Accepetd_By.Name.slice(0, 5)}...`
                : runnig.Accepetd_By.Name}
            </span>

          </div>

        </div>


        {/* Main */}
        <div className="prince_running_match_body">

          {/* Entry */}
          <div className="prince_running_side_box">

            <span className="prince_running_side_title">
              ENTRY FEE
            </span>

            <div className="prince_running_money">
              <img
                src="/images/moneyrupee.png"
                alt=""
              />

              <strong>
                {runnig.Game_Ammount}
              </strong>
            </div>

          </div>


          {/* VS CENTER */}
          <div className="prince_running_match_center">

            {user == runnig.Accepetd_By._id ||
              user == runnig.Created_by._id ? (

              <Link
                className={`prince_running_match_view ${runnig.Status === "conflict"
                    ? "prince_running_match_conflict"
                    : ""
                  }`}
                to={{
                  pathname: `/viewgame1/${runnig._id}`,
                  state: {
                    prevPath: window.location.pathname
                  },
                }}
              >
                VIEW
              </Link>

            ) : (

              <div className="prince_running_vs_box">

                <span className="prince_running_vs_line"></span>

                <img
                  src="../images/VS-image.png"
                  className="prince_running_match_vs"
                  alt=""
                />

                <span className="prince_running_vs_line"></span>

              </div>

            )}

          </div>


          {/* Prize */}
          <div className="prince_running_side_box prince_running_prize_box">

            <span className="prince_running_side_title">
              WINNING PRIZE
            </span>

            <div className="prince_running_money">

              <img
                src="/images/moneyrupee.png"
                alt=""
              />

              <strong>
                {runnig.Game_Ammount +
                  winnAmount(runnig.Game_Ammount)}
              </strong>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}
